<template>
  <!-- start 弹窗外层 -->
  <div class="dialog-box" v-if="open" @click="preventClick">
    <div class="upgrade-vip">
      <div class="closed-container"  @click="close">
        <img
          class="close-icon"
          src="@/assets/images/vip-close-icon.png"
        />
      </div>
      <img
        v-if="type == 0"
        class="article-bak"
        src="@/assets/images/article-bak-icon.png"
      />
      <img
        v-if="type == 1"
        class="article-bak"
        src="@/assets/images/game-back-icon.png"
      />
      <template v-if="type == 0">
        <div class="intro">该课程文章为付费内容</div>
        <div class="intro">升级会员，解锁无限次练习打字</div>
      </template>
      <template v-if="type == 1">
        <div class="intro">您的免费打字游戏次数已用完</div>
        <div class="intro">升级会员解锁，无限次打字游戏次数</div>
      </template>
      <div class="sj-vip" @click="upgradeVip">升级VIP</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpgradeVip",
  props: {
    open: {
      typeof: Boolean,
      default: false,
    },
    type: {
      typeof: Number,
      default: 0,
    },
  },
  methods: {
    // 升级Vip
    upgradeVip() {
      this.$emit("upgradeVip");
    },
    // 关闭弹窗
    close() {
      this.$emit("close");
    },
    // 防止点击
    preventClick() {},
  },
};
</script>

<style lang="scss" scoped>
.dialog-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .upgrade-vip {
    width: 340px;
    height: 270px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #ffffff;
    border: 1px solid #6090c0;
    border-radius: 4px 4px 4px 4px;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-flow: column;

    .closed-container {
      width: 40px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      top: 8px;
      right: 8px;
      .close-icon {
        width: 30px;
        height: 24px;
      }
    }
    .closed-container:hover {
      background-color: rgba(153, 148, 148, 0.2);
    }
    .article-bak {
      margin-top: 37px;
      width: 180px;
      height: 120px;
    }
    .intro {
      margin-top: 6px;
      font-size: 14px;
      font-weight: 400;
      color: #282a43;
    }
    .sj-vip {
      width: 128px;
      height: 36px;
      background: linear-gradient(90deg, #ffebce 0%, #f8d393 100%);
      border-radius: 3px 3px 3px 3px;
      font-size: 16px;
      font-weight: 500;
      color: #562208;
      text-align: center;
      margin-top: 10px;
      line-height: 36px;
      cursor: pointer;
    }
  }
}
</style>
